import { Site } from '@envato/foundation-types'

const experimentConfig = {
  globalExperiment: {
    experimentId: 'gKIzsB-zQ_CEXG-jI-AyGQ',
    running: true,
    loadingCover: true,
    sites: [
      Site.themeforest,
      Site.graphicriver,
      Site.codecanyon,
      Site.photodune,
      Site.threedocean,
      Site.videohive,
      Site.audiojungle
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false
      },
      1: {
        globalExperiment: true
      }
    }
  },
  homepageNewDesignPhase2: {
    experimentId: 'GjGUxbSFRrCPOvQ9sQUSfw',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: true,
        homepageNewDesignPhase2: false,
        homepageContentHeavy: false
      },
      1: {
        homepageNewDesign: true,
        homepageNewDesignPhase2: true,
        homepageContentHeavy: false
      },
      2: {
        homepageNewDesign: true,
        homepageContentHeavy: true
      }
    }
  },
  categoryPageElementsBlockOrder: {
    experimentId: 'A4oyXGwaSP-B7H3N98DApA',
    running: true,
    loadingCover: false,
    sites: [
      Site.audiojungle,
      Site.themeforest,
      Site.videohive,
      Site.codecanyon,
      Site.graphicriver
    ],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        categoryPageBlocksB: true,
        hideBanner: false
      },
      1: {
        categoryPageBlocksC: true,
        hideBanner: false
      },
      2: {
        categoryPageBlocksD: true,
        hideBanner: false
      },
      3: {
        categoryPageBlocksB: true,
        hideBanner: true
      },
      4: {
        categoryPageBlocksC: true,
        hideBanner: true
      },
      5: {
        categoryPageBlocksD: true,
        hideBanner: true
      }
    }
  }
}

export default experimentConfig
